<div
  [formGroup]="group"
  [ngClass]="{
    'form-group--checkmark': !config.enableShowPassword && control.isValid && !formControl?.disabled,
    'form-group--icon': config.enableShowPassword
  }"
>
  @if (!config.emitChange) {
    <input
      [type]="config.passwordControl.type"
      class="form-control"
      [formControlName]="config.name"
      [id]="config.name"
      [attr.placeholder]="config.placeholder"
      [attr.autocomplete]="config.autocomplete ? config.autocomplete : null"
      [attr.aria-required]="isRequired ? 'true' : 'false'"
      [attr.aria-invalid]="control.hasError ? 'true' : null"
    />
  }
  @if (config.emitChange) {
    <input
      [type]="config.passwordControl.type"
      class="form-control"
      [id]="config.name"
      [formControlName]="config.name"
      [attr.placeholder]="config.placeholder"
      [attr.autocomplete]="config.autocomplete ? config.autocomplete : null"
      [attr.aria-required]="isRequired ? 'true' : 'false'"
      [attr.aria-invalid]="control.hasError ? 'true' : null"
      (change)="onChange($event)"
    />
  }
  @if (config.enableShowPassword) {
    <button
      type="button"
      class="input-button"
      (click)="toggleShowPassword()"
      [attr.aria-label]="
        (config.passwordControl.type === formType.password ? 'account.label.show_password' : 'account.label.hide_password') | translate
      "
    >
      <i
        class="icon icon--dark"
        [ngClass]="config.passwordControl.type === formType.password ? 'icon-ui-eye-open' : 'icon-ui-eye-closed'"
        [ngStyle]="config.eyeColor && { 'background-color': '#' + config.eyeColor.color }"
      ></i>
    </button>
  }
</div>
